import React from "react";
import styles from "./Home.module.sass";
import TooltipGlodal from "../../components/TooltipGlodal";
import Overview from "./Overview";
import AbsenceAlerts from "./AbsenceAlerts";
import ArticleCarousel from "./ArticleCarousel";
import { useAuth } from "../../contexts/AuthContext";

const CompanyDashboard = () => {
  const { currentUser } = useAuth();

  return (
    <>
      <div className={styles.row}>
        <div className={styles.col}>
          <Overview 
            className={styles.card} 
            currentUser={currentUser}
          />
          <ArticleCarousel 
            className={styles.card}
            currentUser={currentUser}
          />
        </div>
        <div className={styles.col}>
          <AbsenceAlerts className={styles.card} />
        </div>
      </div>
      <TooltipGlodal />
    </>
  );
};

export default CompanyDashboard;
